const uiConfig = {
  H: {
    blacked_out: true,
    offsets: {
      right_panel: { top: 0, left: -11 },
      tournaments_panel: { top: 0, left: -1430 }
    },
  },
  V: {
    blacked_out: true,
    offsets: {
      top: -100,
      left: 0,
    },
  }
};

export {
  uiConfig,
}
